/*============================================================================
  悬浮购物车功能 - Sticky Cart Handler
  包含：滚动监听、规格选择器事件绑定、Ajax 加购
  
  依赖：jQuery, theme.AjaxProduct
==============================================================================*/

(function() {
  'use strict';

  // 等待页面完全加载
  window.addEventListener('load', function() {
    
    // 悬浮购物车规格选择器事件绑定
    function initStickyCartVariants() {
      // 获取当前商品的 section ID
      var productSection = document.querySelector('[data-section-type="product"]');
      if (!productSection) return;
      
      var sectionId = productSection.getAttribute('data-section-id');
      
      // 为悬浮购物车的表单初始化 Ajax 加购功能（与商详页保持一致）
      // 当购物车类型为侧边栏时，使用 Ajax 加购并打开购物车侧边栏
      var stickyCartForm = document.querySelector('.stickyCart form');
      if (stickyCartForm && window.theme && theme.settings.cartType === 'drawer') {
        // 悬浮购物车的按钮类名是 .product-form__cart-submit，需要明确指定
        new theme.AjaxProduct(stickyCartForm, '.product-form__cart-submit');
      }
      
      // 规格选项点击事件（使用 jQuery 以保持与主题一致）
      $(".stickyOptions .vrOpt").on('click', function(e) {
        var value = $(this).attr('data-val');
        var number = parseInt($(this).attr('data-no'));
        var text = $(this).text();
        
        // 提取规格名称（去掉价格部分）
        // 文本格式是 "Black / S - $29.99"，只取 " - " 之前的部分
        var variantTitle = text.split(' - ')[0];
        
        // 更新选中的规格显示（只显示规格名称，不显示价格）
        $(".selectedOpt").text(variantTitle);
        
        // 触发 select 的 change 事件，让主题的变体处理逻辑生效
        $(".stickyCart .selectbox").val(value).trigger('change');
        
        // 隐藏下拉列表
        $(".stickyOptions ul").slideUp("fast");
        
        // 更新商品图片 - CF 项目使用 data-variant-json 存储变体数据
        try {
          // 尝试从 textarea[data-variant-json] 获取变体数据
          var variantJsonEl = productSection.querySelector('[data-variant-json]');
          if (variantJsonEl) {
            var variants = JSON.parse(variantJsonEl.textContent);
            
            if (variants && variants[number]) {
              var selectedVariant = variants[number];
              
              // 更新图片 - 检查 featured_image 或 featured_media
              if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
                var imgSrc = selectedVariant.featured_image.src;
                // 转换为 60x60 缩略图
                var thumbnailSrc = imgSrc.replace(/(\.[^\.]*$|$)/, '_60x60' + '$&');
                $(".stickyCart .product-featured-img").attr('src', thumbnailSrc);
              } else if (selectedVariant.featured_media && selectedVariant.featured_media.preview_image) {
                var imgSrc = selectedVariant.featured_media.preview_image.src;
                var thumbnailSrc = imgSrc.replace(/(\.[^\.]*$|$)/, '_60x60' + '$&');
                $(".stickyCart .product-featured-img").attr('src', thumbnailSrc);
              }
            }
          }
        } catch(err) {
          console.log('Error updating sticky cart image:', err);
        }
      });
      
      // 点击选中的规格区域显示/隐藏下拉列表
      $(".stickyCart .selectedOpt").on('click', function() {
        $(".stickyOptions ul").slideToggle("fast");
      });
      
      // 点击页面其他地方时隐藏下拉列表
      $(document).on('click', function(e) {
        if (!$(e.target).closest('.stickyOptions').length) {
          $(".stickyOptions ul").slideUp("fast");
        }
      });
    }
    
    // 使用 Intersection Observer 监测元素可见性
    function initStickyCartVisibility() {
      if (!$('.stickyCart').length || !$('body').hasClass('template-product')) {
        return;
      }

      // 检测设备类型（简单判断：宽度 > 766px 为 PC 端）
      var isDesktop = window.innerWidth > 766;
      var targetElement;
      
      if (isDesktop) {
        // PC端：监测整个商详页内容区域
        targetElement = document.querySelector('.page-content.page-content--product');
        if (!targetElement) {
          console.log('未找到商详页内容区域，使用滚动距离判断');
          useFallbackScrollDetection();
          return;
        }
      } else {
        // M端：监测加购按钮
        targetElement = document.querySelector('[data-add-to-cart]');
        if (!targetElement) {
          console.log('未找到原始加购按钮，使用滚动距离判断');
          useFallbackScrollDetection();
          return;
        }
      }

      // 使用 Intersection Observer API 监测元素是否在视口内
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          // entry.isIntersecting 为 true 表示元素在视口内（可见）
          // 为 false 表示元素不在视口内（不可见）
          
          // entry.boundingClientRect.top 表示元素相对于视口顶部的距离
          // top < 0 说明元素在视口上方（已经向下滚过了）
          // top > 0 说明元素在视口下方或视口内
          var isAboveViewport = entry.boundingClientRect.top < 0;
          
          if (entry.isIntersecting) {
            // 目标元素可见，隐藏悬浮购物车
            $("body.template-product").css('padding-bottom', '0');
            $(".stickyCart").slideUp();
          } else if (isAboveViewport) {
            // 目标元素不可见 且 在视口上方（已经滚过了），显示悬浮购物车
            $("body.template-product").css('padding-bottom', '70px');
            $(".stickyCart").slideDown();
          } else {
            // 目标元素不可见 但 在视口下方（还没滚到），隐藏悬浮购物车
            $("body.template-product").css('padding-bottom', '0');
            $(".stickyCart").slideUp();
          }
        });
      }, {
        // 配置选项：
        // threshold: 0 表示只要有一点点进入或离开视口就触发
        // rootMargin 可以设置提前触发的区域（类似偏移量）
        threshold: 0,
        rootMargin: '0px'
      });

      // 开始观察目标元素
      observer.observe(targetElement);
      
      // 监听窗口大小变化，重新初始化
      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          var newIsDesktop = window.innerWidth > 766;
          if (newIsDesktop !== isDesktop) {
            // 设备类型改变，重新初始化
            observer.disconnect();
            initStickyCartVisibility();
          }
        }, 250);
      });
    }
    
    // 降级方案：如果找不到按钮，使用滚动距离判断
    function useFallbackScrollDetection() {
      function handleStickyCartScroll() {
        if (!$('.stickyCart').length) {
          return;
        }

        var scrollTop = $(window).scrollTop();
        var isProductPage = $('body').hasClass('template-product');
        
        if (scrollTop > 600 && isProductPage) {
          // 显示悬浮购物车
          $("body.template-product").css('padding-bottom', '70px');
          $(".stickyCart").slideDown();
        } else {
          // 隐藏悬浮购物车
          $("body.template-product").css('padding-bottom', '0');
          $(".stickyCart").slideUp();
        }
      }
      
      // 初始检查
      handleStickyCartScroll();
      
      // 滚动事件监听（使用节流优化性能）
      var scrollTimer;
      $(window).on('scroll', function() {
        if (scrollTimer) {
          clearTimeout(scrollTimer);
        }
        scrollTimer = setTimeout(function() {
          handleStickyCartScroll();
        }, 10);
      });
    }
    
    // 初始化规格选择器
    initStickyCartVariants();
    
    // 初始化悬浮购物车可见性控制
    initStickyCartVisibility();
  });
})();

